import { ButtonView, Plugin } from 'ckeditor5'
import { PasteCommand } from './PasteCommand'

export class PastePlugin extends Plugin {
  static get pluginName() {
    return 'Paste'
  }

  init() {
    const editor = this.editor

    // Add the paste command
    editor.commands.add('paste', new PasteCommand(editor))

    // Add the paste button to the toolbar
    editor.ui.componentFactory.add('paste', (locale) => {
      const command = editor.commands.get('paste')
      const buttonView = new ButtonView(locale)

      buttonView.set({
        label:
          global.window.CKEDITOR_TRANSLATIONS[locale.contentLanguage]
            ?.dictionary?.Paste,
        icon: '<svg></svg>',
        tooltip: true,
      })

      if (command) {
        buttonView.bind('isEnabled').to(command, 'isEnabled')
      }

      buttonView.on('execute', () => {
        editor.execute('paste')
      })

      return buttonView
    })
  }
}
